import { ia } from 'lib/helpers/utility';
import { getAgGridData } from 'lib/helpers/pdf/tableExport/lib/getAgGridData';

import { getCurrentPageRows } from './getCurrentPageRows';

export const fetchExportRows = async ({
  navigate,
  finalColumns,
  isExportAllColumns,
  isCurrentPageOnly,
  gridApi,
  getData,
  name,
  filters,
  queryParams,
  page,
  limit,
  sortField
}) => {
  const fetchBackendData = async (params) => {
    const response = await getData(navigate, { ...queryParams, filters, ...params });

    // The backend answers 200 on business errors, so an error body would otherwise read as
    // an empty table and the user would be told there was nothing to export.
    if (!ia(response) && response?.code !== undefined && response.code !== 0) {
      throw new Error(response.error || 'Export data could not be loaded');
    }

    return (ia(response) ? response : response?.[name]) || [];
  };

  if (isCurrentPageOnly) {
    if (gridApi) return getCurrentPageRows(gridApi);

    return fetchBackendData({
      exporting: false,
      page,
      limit,
      ...(sortField && { sort: sortField })
    });
  }

  if (typeof getData === 'function')
    return fetchBackendData({ exporting: true, pagination: false, page: 1 });

  if (gridApi) return getAgGridData(gridApi, finalColumns, isExportAllColumns).rows;

  return [];
};
